import * as React from 'react';

import useFluxStore from 'src/flux/useFluxStore';

import SenseLogo from 'src/images/sense-logo.svg';

import css from './content-subscription.css';
import {useSelector} from 'react-redux';
import {selectBrandingSettings} from 'src/selectors/content-subscription';


type Props = {
  children: React.ReactNode;
  params: {
    sentEventId?: string;
    unsubscribeCategoryId: string | null | undefined;
    attributeValue: string | null | undefined;
    attributeName: string | null | undefined;
    entityId?: string;
    entityType?: string;
    deliveryAddress?: string;
    isDebugEntity?: boolean;
    trackingId?: string;
  };
};

const ContentSubscriptionShell = ({children, params}: Props) => {
  const store = useFluxStore();
  const brandingSettings = useSelector((state) => {
    if (params.trackingId) {
      return selectBrandingSettings(state);
    }
    return {};
  });
  let logo, logoLink, brandColor;
  if (params.sentEventId) {
    const sentEvent = store.sentEvents.byId(params.sentEventId);
    if (sentEvent) {
      logo = sentEvent.brandingSettings.logo;
      logoLink = sentEvent.brandingSettings.logo_link;
      brandColor = sentEvent.brandingSettings.color;
    }
  }
  if (params.trackingId) {
    logo = brandingSettings.logo;
    // @ts-expect-error - TS2339 - Property 'logoLink' does not exist on type 'ApiBrandingSettings'.
    logoLink = brandingSettings.logoLink;
    brandColor = brandingSettings.color;
  }

  return (
    <div className={css.container}>
      <div className={css.topBranding} style={{backgroundColor: brandColor}} />
      <div className={css.contentBox}>
        <div className={css.contentBoxHeader}>
          <div className={css.contentBoxHeaderInfo}>
            <Logo logo={logo} logoLink={logoLink} />
            <label className={css.contentBoxHeaderInfoText}>
              {params.unsubscribeCategoryId
                ? 'Unsubscribe Content Category'
                : 'Manage Subscriptions'}
            </label>
          </div>
        </div>
        <div className={css.contentBoxContent}>{children}</div>
      </div>
    </div>
  );
};

const Logo = ({logo, logoLink}: {logo?: string; logoLink?: string}) => {
  if (logo) {
    return logoLink ? (
      <a href={logoLink} rel="noopener noreferrer" target="_blank">
        <img className={css.contentBoxHeaderInfoLogo} src={logo} />
      </a>
    ) : (
      <img className={css.contentBoxHeaderInfoLogo} src={logo} />
    );
  }
  return (
    <a href="/" className={css.contentBoxHeaderInfoLogo}>
      <SenseLogo />
    </a>
  );
};

export default ContentSubscriptionShell;
